import theme from "../../theme";
// @ts-expect-error
import match from "autosuggest-highlight/match";
// @ts-expect-error
import parse from "autosuggest-highlight/parse";

type HighlightLabelProps = {
  highlight?: string;
  label: string;
};

export const HighlightLabel = ({ highlight, label }: HighlightLabelProps) => {
  if (!highlight) return label;

  const matches = match(label.toLowerCase(), highlight.toLowerCase(), {
    insideWords: true,
    findAllOccurrences: true,
  });

  const parts = parse(label, matches);

  // @ts-expect-error
  return parts.map((part, index) => (
    <span
      key={index}
      style={{
        backgroundColor: part.highlight
          ? `${theme.palette.primary.main}25`
          : "inherit",
        fontWeight: part.highlight ? 700 : 400,
      }}
    >
      {part.text}
    </span>
  ));
};
